Object.defineProperty(exports, "__esModule", { value: true });
exports.TransportType = void 0;
var TransportType;
(function (TransportType) {
    TransportType["XHR"] = "xhr";
    TransportType["SendBeacon"] = "beacon";
    TransportType["Fetch"] = "fetch";
})(TransportType = exports.TransportType || (exports.TransportType = {}));
//# sourceMappingURL=transport.js.map